module.exports = __webpack_public_path__ + "img/list-ul.66110252.svg";